import { SimNaoEnum } from 'components/form'
import { AtendimentoProfissionalPreNatal, ResultadoExamePreNatalInput } from 'graphql/types.generated'
import { tipoEdemaRecord } from 'types/enums'
import { dateAsYyyyMmDd } from 'util/date/formatDate'
import { MedicoesPreNatal } from 'view/atendimentos/detail/components/modals/types/model-historicoPreNatal'

import {
  ResultadoEspecificoPrenatal,
  ResultadoExameEspecificoModel,
} from '../../objetivo/resultados-exames/model-resultadosExames'
import { PreNatalFormModel } from '../../pre-natal/model-preNatal'
import { IdadeGestacionalAcompanhamentoPreNatal, PeriodoGestacionalQueryModel } from './model-acompanhamentoPreNatal'
import { MedicaoAtendProfPreNatal } from './util/util-acompanhamentoPreNatal'

export function convertResultadoExameToResultadoExamePreNatalInput(
  resultadoExame: ResultadoExameEspecificoModel
): ResultadoExamePreNatalInput {
  const resultado = resultadoExame.resultado as ResultadoEspecificoPrenatal
  return {
    dataRealizacao: resultadoExame.dataRealizado,
    idadeGestacionalDias: resultado?.idadeGestacional?.dias,
    idadeGestacionalSemanas: resultado?.idadeGestacional?.semanas,
    dataProvavelParto: resultado?.dpp,
  }
}

export function convertPeriodoGestacionalToIdadeGestacional(
  periodoGestacional?: PeriodoGestacionalQueryModel
): IdadeGestacionalAcompanhamentoPreNatal {
  return (
    periodoGestacional && {
      ecograficaEmDias: periodoGestacional.idadeGestacionalEcograficaEmDias,
      cronologicaEmDias: periodoGestacional.idadeGestacionalCronologicaEmDias,
      fonteIdadeGestacional: periodoGestacional.fonteIdadeGestacional,
    }
  )
}

export function convertMedicoesAtendimentoAtual(
  dataAtendimento: number,
  preNatalAtendimentoAtual: PreNatalFormModel,
  pesoAtendimentoAtual: number,
  quantidadeMedicoesAtendimentosAnteriores: number
): MedicoesPreNatal {
  return {
    numeroConsulta: quantidadeMedicoesAtendimentosAnteriores + 1,
    dataDaMedicao: dateAsYyyyMmDd(dataAtendimento),
    movimentacaoFetal:
      preNatalAtendimentoAtual?.movimentacaoFetal && preNatalAtendimentoAtual.movimentacaoFetal === SimNaoEnum.SIM,
    edema: tipoEdemaRecord[preNatalAtendimentoAtual?.edema],
    batimentoCardiacoFetal: preNatalAtendimentoAtual?.batimentoCardiacoFetal?.toString(),
    batimentoCardiacoFetal2: preNatalAtendimentoAtual?.batimentoCardiacoFetal2?.toString(),
    alturaUterina: preNatalAtendimentoAtual?.alturaUterina?.toString(),
    peso: pesoAtendimentoAtual,
    isRegistradoAgora: true,
  }
}

export function convertMedicoesUltimaGestacao(
  indexMedicao: number,
  medicao: MedicaoAtendProfPreNatal,
  atendimentoProfissionalPreNatal: AtendimentoProfissionalPreNatal,
  dataMedicao: number | Date
): MedicoesPreNatal {
  return {
    numeroConsulta: indexMedicao + 1,
    dataDaMedicao: dateAsYyyyMmDd(dataMedicao),
    movimentacaoFetal: atendimentoProfissionalPreNatal?.movimentacaoFetal,
    edema: tipoEdemaRecord[atendimentoProfissionalPreNatal?.tipoEdema],
    batimentoCardiacoFetal: medicao?.valorBatimentoCardiacoFetal,
    batimentoCardiacoFetal2: medicao?.valorBatimentoCardiacoFetal2,
    alturaUterina: medicao?.valorAlturaUterina,
    pressaoArterial: medicao?.valorPressaoArterial,
    peso: medicao?.valorPeso,
    glicemiaCapilar: medicao?.valorGlicemia,
    isRegistradoAgora: false,
  }
}
